module.exports = __webpack_public_path__ + "img/plan_delete.af370328.svg";